import React, { Component } from 'react';
import _ from "lodash";
import "./otrosservicios.css";
class OtrosServicios extends Component {
    renderOtrosServicios(otros){
        return _.map(otros, otroservicio => {
            return (
                <div key={otroservicio.id} className="otros-servicios-content-item" style={{backgroundImage: "url("+otroservicio.bg+")"}}>
                    <div className="overlay">
                        <div className="otros-servicios-content-item-row">
                            <div className="otros-servicios-content-item-row1">
                               <img src={otroservicio.icon} alt={otroservicio.alt}/>
                            </div>
                            <div className="otros-servicios-content-item-row2">
                                <div className="otros-servicios-content-item-title montserrat fw-bold">
                                    {otroservicio.title}
                                </div>
                                <div className="otros-servicios-content-item-description montserrat fw-medium">
                                    {otroservicio.description}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        });
    }

    render() {
        return (
            <div className="otros-servicios">
                <div className={`section-title montserrat fw-bold ${this.props.visible ? "animated fadeInUp" : "opa-0"}`}>
                    <h2>Otros Servicios</h2>
                    <div className="section-title-line"/>
                </div>
                <div className="otros-servicios-content">
                    {this.renderOtrosServicios(this.props.content.servicios)}
                </div>
            </div>
        );
    }
}

export default OtrosServicios;


// WEBPACK FOOTER //
// ./src/sections/OtrosServicios.js